import { computed, defineComponent, onMounted, reactive, ref } from "vue";
import { Form } from "ant-design-vue";
import { message } from "ant-design-vue";
import { useRoute, useRouter } from "vue-router";
import { mergeAjaxDataToForm } from "@/utils";
import { MaterialCategorySelect, UnitSelect, BrandSelect } from "@/components";
import { formRules } from "./library-form-btn.constant";
import { BizFileService, TabService } from "@/core";
import { notifyEmitter, submitSuccessEmitter } from "@/utils/emitter";
import { onSuccess } from "@/utils";
import { LibraryReq } from "../../library.interface";
import { LibraryService } from "../../library.service";
import MaterialCategorySelectAdd from "@/components/material-category-select-add/index.vue";
import FormBtn from "@/views/material/unit/list/form-btn/index.vue";
import { FilePageReq } from "@/core/services/biz-file.interface";
import _ from "lodash";

export default defineComponent({
  name: "LibraryForm",
  components: {
    MaterialCategorySelect,
    UnitSelect,
    BrandSelect,
    FormBtn,
    MaterialCategorySelectAdd,
  },
  props: {
    id: {
      type: String,
      default: "",
    },

    isEdit: {
      type: Boolean,
    },
  },
  emits: {
    refresh: null,
  },
  setup(props, { attrs, slots, emit }) {
    const formRef = reactive(new LibraryReq());
    const ruleRef = reactive(formRules);
    const { resetFields, validate, validateInfos } = Form.useForm(formRef, ruleRef);
    const visible = ref(false);

    const { run: runDetail, loading: detailLoading } = LibraryService.useDetailApi();
    // const { run: runCreate, loading: createLoading } = LibraryService.useCreateApi();
    const { run: runEdit, loading: editLoading } = LibraryService.useEditApi();

    const { data, run: runCreate, loading: createLoading } = LibraryService.useCreateApi();

    // const { data: unitDate, refresh } = LibraryService.useSimpleListApi();
    const submit = async () => {
      try {
        await validate();
        props.isEdit && (await uploadFilesFn());

        const res = props.isEdit ? await runEdit(props.id, formRef) : await runCreate(formRef);
        if (res.respCode === "0000") {
          message.success(res.respDesc);
          closeDrawer();
          emit("refresh");
          notifyEmitter.emit("refreshTree");
          if (!props.isEdit) {
            onSuccess(res.data?.id, "MATERIAL");
          }
        }
      } catch (e) {
        // ignore
      }
    };
    const showCreateDrawer = async () => {
      visible.value = true;
    };

    const showEditDrawer = async () => {
      visible.value = true;
      if (props.isEdit) {
        const res = await runDetail(props.id);
        if (res.respCode === "0000") {
          mergeAjaxDataToForm(res.data, formRef);
          await getFileList(props.id);
        }
      }
    };
    const { data: fileList, run: runFile } = BizFileService.usePageApi();
    const { run: uploadFiles } = BizFileService.useCreateApi();
    const uploadFilesFn = async () => {
      const files = formRef.fileList.map((item: any) => {
        item.bizId = props.id;
        item.bizType = "MATERIAL";
        return item;
      });
      await uploadFiles(files, props.id, "MATERIAL");
    };
    const getFileList = async (bizId) => {
      const fileReq = new FilePageReq();
      fileReq.merge({
        bizId,
        bizType: "MATERIAL",
        current: 1,
        size: 100,
      });
      await runFile(fileReq);
      formRef.fileList = _.cloneDeep(fileList.value) as any;
    };
    const closeDrawer = () => {
      visible.value = false;
      resetFields();
    };

    // const cancel = async () => {
    //   TabService.closeCurrentTab();
    //   router.back();
    // };

    // 切换所属分类时, 清空品牌
    const onMaterialCategoryChange = () => {
      formRef.materialCategoryBrandId = undefined;
    };
    let AddUnitId = "";
    notifyEmitter.on("addUnitBack", (e) => {
      AddUnitId = e;
    });
    notifyEmitter.on("unitIdTrue", (e) => {
      if (Boolean(e)) {
        formRef.unitId = AddUnitId;
      }
    });

    onMounted(async () => {
      // if (props.isEdit) {
      //   const res = await runDetail(props.id);
      //   if (res.respCode === "0000") {
      //     mergeAjaxDataToForm(res.data, formRef);
      //   }
      // }
    });

    return {
      formRef,
      validateInfos,
      detailLoading,
      createLoading,
      editLoading,
      submit,
      onMaterialCategoryChange,
      showCreateDrawer,
      closeDrawer,
      showEditDrawer,
      visible,
      // refresh,
    };
  },
});
